"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ProductBottomStickyCard } from "./product-sticky-bottom-card";
export const ProductStickyBottom = t0 => {
  const $ = _c(12);
  const {
    product,
    variant,
    subscription,
    currency,
    locale,
    domain,
    theme,
    settings
  } = t0;
  const [show, setShow] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const button = document.getElementById("button-add-to-cart");
      const observer = new IntersectionObserver(t3 => {
        const [entry] = t3;
        if (entry) {
          setShow(!entry.isIntersecting);
        }
      }, {
        threshold: 0,
        rootMargin: "-100px 0px 0px 0px"
      });
      if (button) {
        observer.observe(button);
      }
      return () => {
        if (button) {
          observer.unobserve(button);
        }
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== currency || $[3] !== domain || $[4] !== locale || $[5] !== product || $[6] !== settings || $[7] !== show || $[8] !== subscription || $[9] !== theme || $[10] !== variant) {
    t3 = <ProductBottomStickyCard product={product} subscription={subscription} variant={variant} currency={currency} locale={locale} domain={domain} theme={theme} show={show} settings={settings} />;
    $[2] = currency;
    $[3] = domain;
    $[4] = locale;
    $[5] = product;
    $[6] = settings;
    $[7] = show;
    $[8] = subscription;
    $[9] = theme;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};